import { Outlet, useLocation } from 'react-router-dom'
import Layout from '@/shared/components/Layout/Layout'
import { AppTabsRoute } from '@/shared/components/AppTabs/AppTabsRoute'
import tabStyles from '@/shared/components/AppTabs/AppTabs.module.scss'

export type FeatureTabsLayoutTab = {
  segment: string
  label: string
}

type FeatureTabsLayoutProps = {
  breadcrumbs: string[]
  basePath: string
  tabs: FeatureTabsLayoutTab[]
  shouldShowTabs?: (pathname: string) => boolean
  getActiveSegment?: (pathname: string) => string
}

/**
 * Shared layout for pages where tabs are driven by the URL.
 * It keeps the duplicated `Layout + AppTabsRoute + Outlet` logic in one place.
 */
export default function FeatureTabsLayout({
  breadcrumbs,
  basePath,
  tabs,
  shouldShowTabs,
  getActiveSegment,
}: FeatureTabsLayoutProps) {
  const { pathname } = useLocation()

  const showTabs = shouldShowTabs ? shouldShowTabs(pathname) : true
  const fallbackActive = tabs[0]?.segment ?? ''
  const activeSegment = getActiveSegment ? getActiveSegment(pathname) : fallbackActive

  return (
    <Layout breadcrumbs={breadcrumbs}>
      {showTabs && (
        <AppTabsRoute
          basePath={basePath}
          tabs={tabs}
          activeSegment={activeSegment}
        />
      )}
      <div className={showTabs ? tabStyles.tabsContent : undefined}>
        <Outlet />
      </div>
    </Layout>
  )
}

